import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ddcbbe4e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./assets/css/init/common.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./assets/fonts/iconfont.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports